export default [
{
	"patternName" : "Herkimer Plaid",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Shmooopie Dots",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Sotomayor Stripe",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Four Barrel Plaid",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Quantas Plaid",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Per Diem Dots",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Santitos Stripe",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Quadrant Plaid",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},	{
	"patternName" : "Stilton Plaid",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Pookie Dots",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Tiffany Stripe",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Biffany Plaid",
	"image" : "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1553020738-mens-best-ties-3-1553020725.jpg?crop=1xw:1xh;center,top&resize=768:*",
	"productType": "tie"
},
{
	"patternName" : "Herkimer Plaid",
	"image" :  "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Shmooopie Dots",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Sotomayor Stripe",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Four Barrel Plaid",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Quantas Plaid",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Per Diem Dots",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Santitos Stripe",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Quadrant Plaid",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},	{
	"patternName" : "Stilton Plaid",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Pookie Dots",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Tiffany Stripe",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Biffany Plaid",
	"image" : "https://shop.whitehousehistory.org/media/catalog/product/cache/1/image/700x/9df78eab33525d08d6e5fb8d27136e95/v/v/vvredbowtie_2.png",
	"productType": "bowTie"
},
{
	"patternName" : "Herkimer Plaid",
	"image" :  "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Shmooopie Dots",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Sotomayor Stripe",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Four Barrel Plaid",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Quantas Plaid",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Per Diem Dots",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Santitos Stripe",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Quadrant Plaid",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},	{
	"patternName" : "Stilton Plaid",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Pookie Dots",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Tiffany Stripe",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Biffany Plaid",
	"image" : "https://www.bowtiemart.com/media/catalog/product/cache/e4d64343b1bc593f1c5348fe05efa4a6/p/i/pink-and-blue-madras-pocket-square.jpg",
	"productType": "pocketSquare"
},
{
	"patternName" : "Herkimer Plaid",
	"image" :  "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Shmooopie Dots",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Sotomayor Stripe",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Four Barrel Plaid",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Quantas Plaid",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Per Diem Dots",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Santitos Stripe",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Quadrant Plaid",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},	{
	"patternName" : "Stilton Plaid",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Pookie Dots",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Tiffany Stripe",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
},
{
	"patternName" : "Biffany Plaid",
	"image" : "https://shop.amnh.org/media/catalog/product/cache/207e23213cf636ccdef205098cf3c8a3/a/b/abstract_birds_scarf.jpg",
	"productType": "scarf"
}
]


// WEBPACK FOOTER //
// ./src/services/OrgPatternService.js